import * as React from "react";
import { Route } from 'react-router-dom';
import Connect from './OneDrive/Connect';
import ChooseDbFiles from './OneDrive/ChooseDbFiles';

export default [
    <Route noLayout exact path="/onedrive-connect" component={Connect} />,
    <Route exact path="/onedrive-setup" component={ChooseDbFiles} />,
];